export default __webpack_public_path__ + "static/hero_bg_punk-4892297a7626d630b4ca21a2e55dd8d7.webp";